(() => {
  'use strict';
  const root = window.Shopify?.routes?.root || '/';
  const notice = document.querySelector('[data-bag-notice]');
  const closeMenu = menu => { menu.open = false; document.body.classList.remove('menu-open'); menu.querySelector('summary')?.focus(); };
  document.addEventListener('toggle', event => {
    if (event.target.matches('[data-menu]')) document.body.classList.toggle('menu-open', event.target.open);
  }, true);
  document.addEventListener('click', event => {
    const close = event.target.closest('[data-close-menu]');
    if (close) closeMenu(close.closest('[data-menu]'));
    const menuLink = event.target.closest('[data-menu] a');
    if (menuLink) closeMenu(menuLink.closest('[data-menu]'));
    if (event.target.closest('[data-dismiss-notice]')) notice.hidden = true;
    const galleryLink = event.target.closest('[data-gallery-link]');
    if (galleryLink) {
      event.preventDefault();
      const gallery = galleryLink.closest('.product-gallery');
      const media = gallery.querySelector(`[data-media-id="${galleryLink.dataset.galleryLink}"]`);
      if (media) gallery.querySelector('[data-gallery]').scrollTo({ left: media.offsetLeft - gallery.querySelector('[data-gallery]').offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
  });
  document.addEventListener('keydown', event => {
    const menu = document.querySelector('[data-menu][open]');
    if (!menu) return;
    if (event.key === 'Escape') closeMenu(menu);
    if (event.key === 'Tab') {
      const focusables = [...menu.querySelectorAll('summary, a, button, input')].filter(el => el.getClientRects().length && el.type !== 'hidden');
      const first = focusables[0], last = focusables.at(-1);
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  });
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!form.matches('[data-product-form]') || !window.fetch) return;
    if (event.submitter && !event.submitter.matches('[data-add-button], .quick-add')) return;
    event.preventDefault();
    if (form.dataset.submitting) return;
    form.dataset.submitting = 'true';
    const button = event.submitter || form.querySelector('button[type="submit"]');
    const error = form.querySelector('[data-form-error]');
    if (error) error.textContent = '';
    if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
    try {
      const response = await fetch(`${root}cart/add.js`, {method:'POST', body:new FormData(form), headers:{Accept:'application/json'}});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'This piece could not be added. Please try again.');
      if (notice) { notice.querySelector('[data-bag-message]').textContent = 'A lovely choice. Added to your bag.'; notice.hidden = false; }
      // An unsuccessful count refresh must never report a successful add as a failure.
      try { const cartResponse = await fetch(`${root}cart.js`, {headers:{Accept:'application/json'}}); if (cartResponse.ok) { const cart = await cartResponse.json(); document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count); } } catch (_) { /* Native bag remains the source of truth. */ }
    } catch (failure) {
      if (error) error.textContent = failure.message === 'Failed to fetch' ? 'We couldn’t confirm the update. Check your bag before trying again.' : failure.message;
    } finally {
      delete form.dataset.submitting;
      if (button) { button.disabled = form.querySelector('[data-add-label]')?.textContent.trim() === 'SOLD OUT'; button.removeAttribute('aria-busy'); }
    }
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-cart-quantity]')) {
      const message = document.querySelector('[data-cart-update-message]');
      if (message) message.textContent = 'Quantity changed. Select Update bag to refresh your total, or proceed to checkout with this quantity.';
    }
    if (!event.target.matches('[data-variant-selector]')) return;
    const section = event.target.closest('[data-product-section]');
    const variants = JSON.parse(section.querySelector('[data-variants]').textContent);
    const variant = variants.find(v => String(v.id) === event.target.value);
    if (!variant) return;
    const price = section.querySelector('[data-variant-price]');
    price.textContent = variant.price;
    if (variant.compare) { const compare = document.createElement('s'); compare.textContent = variant.compare; price.append(' ', compare); }
    section.querySelector('[data-availability]').textContent = variant.available ? '● Available' : 'Sold out';
    section.querySelector('[data-add-button]').disabled = !variant.available || !!section.querySelector('[data-product-form]').dataset.submitting;
    section.querySelector('[data-add-label]').textContent = variant.available ? 'ADD TO BAG' : 'SOLD OUT';
    const payment = section.querySelector('[data-payment-button]');
    if (payment) payment.hidden = !variant.available;
    const quantity = section.querySelector('[name="quantity"]');
    quantity.min = variant.min; quantity.step = variant.step; quantity.value = variant.min;
    if (variant.max) quantity.max = variant.max; else quantity.removeAttribute('max');
    const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url);
    if (variant.media) section.querySelector(`[data-gallery-link="${variant.media}"]`)?.click();
  });
  function initRecommendations(scope = document) {
    scope.querySelectorAll('[data-recommendations]').forEach(el => {
      if (el.dataset.loaded) return;
      const load = async () => {
        el.dataset.loaded = 'true';
        try {
          const response = await fetch(el.dataset.url);
          if (!response.ok) return;
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const contents = html.querySelector('[data-recommendations]');
          if (contents) el.innerHTML = contents.innerHTML;
        } catch (_) { /* Recommendations are optional; the product remains usable. */ }
      };
      if ('IntersectionObserver' in window) { const observer = new IntersectionObserver(entries => { if (entries.some(entry => entry.isIntersecting)) { observer.disconnect(); load(); } }, {rootMargin:'300px'}); observer.observe(el); } else load();
    });
  }
  initRecommendations();
  document.addEventListener('shopify:section:load', event => initRecommendations(event.target));
  document.addEventListener('shopify:section:unload', () => document.body.classList.remove('menu-open'));
})();
